import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  classApplied = false;
  open = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.classApplied = false;
        this.open = false;
      });
  }

  toggleClass(): void {
    this.classApplied = !this.classApplied;
  }

  closeNavbar(): void {
    this.classApplied = false;
    this.open = false;
  }

  toggleSolutions(event: Event): void {
    event.preventDefault();
    this.open = !this.open;
  }

  get isSolutionsActive(): boolean {
    return this.router.url.startsWith('/products/solution1') ||
           this.router.url.startsWith('/digital-solutions');
  }
}